const mandatePresenceStatuses = Object.freeze({
  not_present: 0,
  physical: 1,
  correspondence: 2,
  phone: 3,
  video: 4,
  pouvoir: 5,
  physical_tab: 6,
  pouvoir_by_video: 7,
  invalid_correspondence: 8,
  pouvoir_by_video_not_present_yet: 9,
});

const correspondenceTypes = Object.freeze({
  not_voted: 0,
  by_app: 1,
  by_email: 2,
  by_post: 3,
});

export { mandatePresenceStatuses, correspondenceTypes };
